import React, { useState, useEffect } from "react";
import CenterWrapper from "../../components/CenterWrapper.jsx";
import GeneralSetupTab from "../../components/GeneralSetupTab";
import SectionHeader from "../../components/SectionHeader";
import Input from "../../components/Input";
import {
  ArrowTopRightOnSquareIcon,
  CheckIcon,
} from "@heroicons/react/20/solid";
import SecondaryButton from "../../components/SecondaryButton";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { WIDGET_URL } from "../../api";
import { Link } from "react-router-dom";
import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import api from "../../api";

const Share = () => {
  const chatbotUuid = localStorage.getItem("chatbot_uuid") || "";
  const [shareUrl, setShareUrl] = useState("");
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    const fetchChatbotSettings = async () => {
      try {
        const response = await api.get(`/api/chatbot/${chatbotUuid}`);
        const chatbot = response.data;
        
        const secondaryColor = `#${chatbot.button_color || "#7856d2"}`;
        const fontColor = `#${chatbot.chat_color || "#7856d2"}`;
        
        const baseUrl = WIDGET_URL.includes("localhost")
          ? `${WIDGET_URL}/agent`
          : `${WIDGET_URL}/agent.html`;
          
        const url = new URL(baseUrl);
        url.searchParams.set("tenantId", chatbotUuid);
        url.searchParams.set("url", window.location.origin);
        url.searchParams.set("secondaryColor", secondaryColor);
        url.searchParams.set("fontColor", fontColor);
        
        setShareUrl(url.toString());
      } catch (error) {
        console.error("Failed to fetch chatbot settings:", error);
        // Fallback to basic URL without colors
        const fallbackUrl = WIDGET_URL.includes("localhost")
          ? `${WIDGET_URL}/agent?tenantId=${chatbotUuid}&url=${window.location.origin}`
          : `${WIDGET_URL}/agent.html?tenantId=${chatbotUuid}&url=${window.location.origin}`;
        setShareUrl(fallbackUrl);
      }
    };

    if (chatbotUuid) {
      fetchChatbotSettings();
    }
  }, [chatbotUuid]);

  const handleCopy = () => {
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <CenterWrapper>
      <GeneralSetupTab title={"Setup"} pageType={"setup"} activeTab={"share"} />

      <SectionHeader
        title="Share"
        description="Share this link with your customers so they can chat with your support agent. "
      />

      <div className="mt-6">
        <Input disabled value={shareUrl} />
      </div>

      <div className="flex gap-6 mt-6">
        <Link to={shareUrl} target="blank" rel="noopener noreferrer">
          <SecondaryButton
            type="button"
            startIcon={
              <ArrowTopRightOnSquareIcon
                aria-hidden="true"
                className="size-6"
              />
            }
          >
            Visit
          </SecondaryButton>
        </Link>

        <div>
          <CopyToClipboard text={shareUrl} onCopy={handleCopy}>
            <SecondaryButton
              type="button"
              startIcon={
                !isCopied ? (
                  <DocumentDuplicateIcon
                    aria-hidden="true"
                    className="size-6"
                  />
                ) : (
                  <CheckIcon aria-hidden="true" className="size-6" />
                )
              }
            >
              {isCopied ? "Copied" : "Copy"}
            </SecondaryButton>
          </CopyToClipboard>
        </div>
      </div>
    </CenterWrapper>
  );
};

export default Share;
